import comp from "./FullScreenLoader";
export default comp;
